import {Deserializable} from '../deserializable';
export  class News implements Deserializable {
  public  documentId: number;
  public  documentTypeID: number;
  public  languageID: number;
  public  subjectID: number;
  public  areaID: number;
  public  organizationID: number;
  public  title: string;
  public  summary: string;
  public  detail: string;
  public  author: string;
  public  sourceOfInformation: string;
  public  inputDate: string;
  public  publicDate: string;
  public  expiryDate: string;
  public  picture: string;
  public  attachFile: string;
  public  fileType: string;
  public  fileName: string;
  public  stateID: number;
  public  usersID: number;
  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
